/**
 * Converts a title into a URL-friendly slug (no ID).
 */
export function titleSlug(title) {
  return (title || 'article')
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')     // remove special chars except hyphens
    .replace(/[\s_]+/g, '-')      // spaces/underscores → hyphens
    .replace(/-+/g, '-')          // collapse multiple hyphens
    .replace(/^-+|-+$/g, '');     // trim leading/trailing hyphens
}

/**
 * Returns the URL path segment for an article.
 * If another article in allArticles shares the same base slug, appends the ID
 * to disambiguate. Otherwise returns a clean slug with no numeric suffix.
 *
 * Example (unique title):    "The Future of AI"  id=5  → "the-future-of-ai"
 * Example (duplicate title): "The Future of AI"  id=5  → "the-future-of-ai-5"
 */
export function articleUrl(title, id, allArticles) {
  const base = titleSlug(title);
  const hasDuplicate = (allArticles || []).some(
    (a) => a.id !== id && titleSlug(a.title) === base
  );
  return hasDuplicate ? `${base}-${id}` : base;
}

/**
 * Extracts the article ID from an ID-suffixed slug: "some-title-42" → 42.
 * Returns null for clean slugs that carry no numeric ID.
 */
export function slugToArticleId(slug) {
  const match = (slug || '').match(/-(\d+)$/);
  return match ? parseInt(match[1], 10) : null;
}
